export default "__VITE_ASSET__CVVwl6QG__"